import React from "react";
import '@aws-amplify/ui-react/styles.css';
import Lottie from 'lottie-react-web'
import successAnimation from '../lottie/Animation-Success.json'
import failedAnimation from '../lottie/Animation-Failed.json'

import {
    Alert,
    Image,
    useTheme,
    Button, Flex
} from '@aws-amplify/ui-react';
import FaceLiveness from "./FaceLiveness";

function ReferenceImage({ faceLivenessAnalysis , tryagain }) {

    if(faceLivenessAnalysis){
        if(window.flutter_inappwebview){
            setTimeout(()=>{
                if(faceLivenessAnalysis.Status === 'SUCCEEDED'){
                    window.flutter_inappwebview.callHandler('scan_success', {});
                }else{
                    window.flutter_inappwebview.callHandler('scan_error', {});
                }
            }, 1000);
        }
    }

    const { tokens } = useTheme();
    return (
        <>
            {faceLivenessAnalysis.Status === 'SUCCEEDED' ? (
                    <Lottie
                        style={{width: "50%"}}
                        options={{
                            loop: false,
                            animationData: successAnimation
                        }}
                    />
                ) :
                (
                    <Flex direction="column">
                        <Lottie
                            style={{width: "50%"}}
                            options={{
                                loop: false,
                                animationData: failedAnimation
                            }}
                        />

                        {/*<Button variation="primary" type="submit" marginTop={tokens.space.large} marginBottom={tokens.space.large} onClick={tryagain}>Try Again</Button>*/}
                    </Flex>
                )}


            {/*<Alert*/}
            {/*    variation="info"*/}
            {/*    isDismissible={false}*/}
            {/*    hasIcon={false}*/}
            {/*    marginTop={tokens.space.large}*/}
            {/*>*/}
            {/*    Session ID: {faceLivenessAnalysis.SessionId}*/}
            {/*</Alert>*/}
            {/*<Alert*/}
            {/*    variation="info"*/}
            {/*    isDismissible={false}*/}
            {/*    hasIcon={false}*/}
            {/*>*/}
            {/*    Status: {faceLivenessAnalysis.Status}*/}
            {/*</Alert>*/}
            {/*<Alert*/}
            {/*    variation="info"*/}
            {/*    isDismissible={false}*/}
            {/*    hasIcon={false}*/}
            {/*>*/}
            {/*    Confidence Score: {faceLivenessAnalysis.Confidence.toFixed(2)}%*/}
            {/*</Alert>*/}



            {/*<Button variation="primary" type="submit" marginTop={tokens.space.large} marginBottom={tokens.space.large} onClick={tryagain}>Try Again</Button>*/}

            {/*<Image*/}
            {/*    src={"data:image/jpeg;base64," + faceLivenessAnalysis.ReferenceImage.Bytes}*/}
            {/*    width="100%"*/}
            {/*    height="100%"*/}
            {/*    objectFit="cover"*/}
            {/*    objectPosition="50% 50%"*/}
            {/*/>*/}
        </>
    );
}

export default ReferenceImage;
